module.exports = __webpack_public_path__ + "img/image156.8ff15507.jpg";